export default "/images/b111ba5115c41b159e2114cc31762a4d.avif";